import { render } from "./mediaLibraryModal.vue?vue&type=template&id=b177d6e8&scoped=true"
import script from "./mediaLibraryModal.vue?vue&type=script&lang=js"
export * from "./mediaLibraryModal.vue?vue&type=script&lang=js"

import "./mediaLibraryModal.vue?vue&type=style&index=0&id=b177d6e8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b177d6e8"]])

export default __exports__